import { render, staticRenderFns } from "./db1.vue?vue&type=template&id=87386b72&"
import script from "./db1.vue?vue&type=script&lang=js&"
export * from "./db1.vue?vue&type=script&lang=js&"
import style0 from "./db1.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "db1.vue"
export default component.exports